<template>
  <transition enter-active-class="transform ease-out duration-300 transition" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div v-show="showModal" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  
  
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.
  
        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div>
          <img class="mx-auto mt-3 h-5 w-auto" src="@/assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index">
          <div class="mt-4 text-center sm:mt-5">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
              A subscription is required.
            </h3>
            <div class="mt-2" style="text-wrap: balance;">
              <p class="text-sm text-gray-600">
                A subscription grants you access to respond to tutoring jobs that are posted to The Tutor Index.
                Subscriptions start from £2.99 per month, which you can cancel anytime.
              </p>
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-6">
          <RouterLink :to="{ name: 'EditTutor-Subscription' }" class="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:col-start-2">Subscribe Now</RouterLink>
        </div>
        <button type="button" @click="$emit('closeModal')" class="mt-4 w-full text-sm text-gray-400 underline hover:text-gray-500" style="text-decoration-thickness: 1px !important; text-underline-offset: 2px">
          Not right now
        </button>
      </div>
    </div>
  </div>
  </transition>
  </template>
  <script>
  
  export default {
    props: {
      showModal: Boolean,
    },
  }
  
  </script>
  